import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducers, effects } from './store';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  RegistrationComponentComponent,
  PhoneVerifyComponentComponent,
  AuthCheckMailComponent,
  PasswordRecoveryComponent,
  PasswordCreatingComponent,
  AuthSuccessMessageComponent,
  AuthLoginComponent,
} from './components';
import {
  AuthFullwidthContainerComponent,
  AuthMainContainerComponent,
} from './containers';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '@app/shared/services/api.service';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';

const ProfileRouting = RouterModule.forChild([
  {
    path: ':status',
    component: AuthMainContainerComponent,
  },
  {
    path: ':status/:status',
    component: AuthFullwidthContainerComponent,
  },
  {
    path: ':status/:status/:token',
    component: AuthFullwidthContainerComponent,
  },
]);

@NgModule({
  declarations: [
    AuthMainContainerComponent,
    AuthLoginComponent,
    RegistrationComponentComponent,
    PhoneVerifyComponentComponent,
    AuthCheckMailComponent,
    PasswordRecoveryComponent,
    AuthFullwidthContainerComponent,
    PasswordCreatingComponent,
    AuthSuccessMessageComponent,
  ],
  imports: [
    ProfileRouting,
    StoreModule.forFeature('users', reducers),
    EffectsModule.forFeature(effects),
    TranslateModule,
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [ApiService],
})
export class AuthModule {
  constructor() {}
}
